import React from 'react';
import PropTypes from 'prop-types';

import Headline from '@components/atoms/headline/headline';
import Copy from '@components/atoms/copy/copy';

import { colorMapping } from '../../../helpers/generateSpherePoints';

const EvaluationCategories = ({ items, locale }) => (
  <div className="evaluation__top-categories">
    {items.map((item, index) => {
      const categoryColor = colorMapping(item.id, true);
      return (
        <div
          key={index}
          className="evaluation__category"
          style={{
            '--category-color': categoryColor
          }}
        >
          <img
            className="evaluation__category-image"
            src={item.image.url}
            srcSet={item.image.srcset}
            sizes="(min-width: 768px) 130px, 100px"
            alt=""
          />
          <div className="evaluation__category-text">
            <Headline tag="h3">
              {Math.round((item.wishCount / item.maxWishes) * 100 * 100) / 100} %
            </Headline>
            <Copy noMargin>{item.title[locale === 'de' ? 0 : 1]}</Copy>
          </div>
        </div>
      );
    })}
  </div>
);

EvaluationCategories.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape()),
  locale: PropTypes.string
};

export default EvaluationCategories;
